import { Cookies } from 'react-cookie';
import { getDeviceType } from './functions'
import { DEVICE_MOBILE } from '../Constants/Constants';

 const getUrlParam = param => {
    let result = null;
    let tmp = [];
    const { hash } = document.location;
    document.location.search
      .substring(1)
      .split("&")
      .forEach(item => {
        tmp = item.split("=");
        if (param === tmp[0]) {
          if (hash !== "" && param === "redirect_uri") {
            result = decodeURIComponent(tmp[1]) + hash;
          } else {
            result = decodeURIComponent(tmp[1]);
          }
        }
      });
    return result;
  };

  export const addValueCookie = async (nameCookie, expiresTime, valueCookie) => {
    const cookies = new Cookies();
    const d = new Date();
    d.setTime(d.getTime() + expiresTime);
    cookies.set(nameCookie, valueCookie, {
      path: '/',
      expires: d,
      secure: true,
      sameSite: "strict"
    })
  }
  
  export const getValueCookie = async nameCookie => {
    const cookies = new Cookies();
    return cookies.get(nameCookie)
  }
  
  export const deleteCookie = nameCookie => {
      const cookies = new Cookies();
      cookies.remove(nameCookie, { path: '/' });
  };

  // Function to check if the process is a desktop process in mobile
  export const fetchIsDesktopProcessInMobile = () => {
    const deviceType = getDeviceType()
    const sessionId = getUrlParam("session");
    const sso = getUrlParam("SSO");
    return deviceType === DEVICE_MOBILE && !!sessionId && !!sso;
  }

  export const validateParams = async () => {
    const clientId = getUrlParam("clientId")
    const data = getUrlParam("data")
    const customerTransaction = getUrlParam("customerTransaction")
    const sessionId = getUrlParam("session");
    const cookie = getUrlParam("SSO");
    const requiredFields = [clientId, data];
    const deviceType = getDeviceType()
    const isDesktopProcessInMobile = fetchIsDesktopProcessInMobile();
    if (!requiredFields.every(field => field)) {
      return { error: true };
    }
    return { customerTransaction: customerTransaction, clientId: clientId, data: data, sessionId: sessionId, cookie: cookie, deviceType: deviceType, isDesktopProcessInMobile: isDesktopProcessInMobile };
  };